// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 900px) {
    main {
        grid-template-columns: 1fr;
        align-items: start;
    }

    .sidebar-column {
        display: grid;
        grid-template-columns: 1fr 2fr;
        gap: 1.5rem;
        align-items: start;
    }

    main.main-detail-open {
        grid-template-columns: minmax(280px, 360px) 1fr;
    }

    main.main-detail-open .sidebar-column {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    main.main-detail-open .detail-column {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        min-width: 0;
    }

    main.main-detail-open .search-section,
    main.main-detail-open .saved-section {
        padding: 1.25rem;
    }

    main.main-detail-open .search-results-grid,
    main.main-detail-open .saved-swimmers-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 600px) {
    .pending-load-fields {
        grid-template-columns: 1fr;
    }

    .filter-section .rankings-age-controls {
        width: 100%;
    }

    .segmented-toggle {
        display: flex;
        width: 100%;
    }

    .segmented-toggle button {
        flex: 1;
        text-align: center;
    }

    .segmented-toggle .age-group-inline {
        flex: 1;
    }

    .segmented-toggle .age-group-affordance {
        width: 100%;
    }

    .filter-collapse-toggle {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        width: 100%;
        padding: 0.375rem 0;
        color: var(--gray-700);
        font-size: 0.8rem;
        text-align: left;
    }

    .filter-collapse-icon {
        font-size: 0.75rem;
        color: var(--gray-400);
    }

    .filter-collapse-summary {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .filter-section.filters-collapsed > *:not(.filter-collapse-toggle) {
        display: none;
    }

    .filter-section.filters-collapsed {
        margin-bottom: 0.75rem;
    }

    .club-group .table-container {
        padding: 0.75rem;
        overflow-x: visible;
    }

    .hide-on-mobile {
        display: none !important;
    }

    .table-container {
        border: none;
        border-radius: 0;
        overflow-x: visible;
    }

    table {
        display: block;
    }

    table thead {
        display: none;
    }

    table tbody {
        display: block;
    }

    table tbody tr {
        display: block;
        margin-bottom: 0.5rem;
        border: 1px solid var(--gray-200);
        border-radius: 6px;
        overflow: hidden;
        background: var(--bg-primary);
    }

    table tbody tr:last-child {
        margin-bottom: 0;
    }

    table tbody tr:hover {
        background: var(--bg-primary);
    }

    table tbody td {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0.3rem 0.75rem;
        border-bottom: 1px solid var(--gray-100);
        gap: 0.75rem;
        text-align: right;
        min-height: auto;
    }

    table tbody td:last-child {
        border-bottom: none;
    }

    table tbody td::before {
        content: attr(data-label);
        font-weight: 600;
        color: var(--gray-600);
        font-size: calc(var(--h1) * 0.6);
        text-align: left;
        flex-shrink: 0;
        width: 38%;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        padding-top: 0.1rem;
    }

    table tbody tr:last-child td {
        border-bottom: none;
    }

    td.card-event-td {
        display: block;
        text-align: left;
    }

    td.card-event-td::before {
        display: none;
    }

    .rankings-cards table tbody tr {
        border-color: var(--gray-100);
        border-radius: 10px;
        box-shadow: 0 1px 2px rbg(0 0 0 / 0.07), 0 1px 3px rgb(0 0 0 / 0.04);
        margin-bottom: 0.6rem;
    }

    .rankings-cards td.card-event-td {
        padding: 0.7rem 0.85rem 0.8rem;
        border-bottom: none;
    }

    .rankings-cards .card-event-header {
        font-size: 0.95rem;
        font-weight: 700;
        line-height: 1.35;
    }

    .rankings-cards .card-inline-time {
        font-size: 1.02rem;
        font-weight: 700;
    }

    .mobile-supplement {
        display: block;
    }

    .mobile-supplement.comparison-rank-list {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        margin-top: 0.35rem;
    }

    table tbody td > div {
        flex: 1;
        justify-content: flex-end;
        min-height: auto !important;
    }

    .splits-drilldown-row {
        border: none;
        border-radius: 0;
        background: transparent;
        margin-bottom: 0;
    }

    .club-group .splits-panel,
    .splits-panel {
        border: 1px solid var(--gray-200);
        border-radius: 6px;
        overflow: hidden;
        padding: 0;
    }

    .splits-panel table {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    .splits-panel thead {
        display: table-header-group;
    }

    .splits-panel tbody {
        display: table-row-group;
    }

    .splits-panel thead tr,
    .splits-panel tbody tr {
        display: table-row;
        margin: 0;
        border: none;
        border-radius: 0;
        background: transparent;
    }

    .splits-panel th,
    .splits-panel td {
        display: table-cell;
        width: 33.33%;
        padding: 0.35rem 0.6rem;
        text-align: right;
        border-bottom: 1px solid var(--gray-100);
    }

    .splits-panel th:first-child,
    .splits-panel td:first-child {
        text-align: left;
    }

    .splits-panel tbody tr:last-child td {
        border-bottom: none;
    }

    .splits-panel td:before {
        display: none;
    }
}

@media (max-width: 768px) {
    .mobile-view:not(.mobile-view-active) { display: none; }
    .mobile-view.mobile-detail-active { display: none; }
    .panel-collapse-toggle { display: none; }
    .swimmer-details-anchor { scroll-margin-top: calc(72px + env(safe-area-inset-top)); }

    body {
        display: flex;
        flex-direction: column;
    }

    #root {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .container {
        flex: 1;
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    main:not(.main-detail-open) {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    main:not(.main-detail-open) .sidebar-column {
        flex: 1;
    }

    main:not(.main-detail-open) .mobile-view.mobile-view-active {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .search-section-empty {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .search-section-empty #searchResults {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .search-section-empty .search-carousel {
        flex: 1;
    }

    .bottom-nav {
        display: flex;
        gap: 0.25rem;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
        background: var(--bg-primary);
        border-top: 1px solid var(--gray-200);
        padding: 0.25rem 0;
        padding-bottom: calc(0.25rem + env(safe-area-inset-bottom));
        padding-left: max(0.5rem, env(safe-area-inset-left));
        padding-right: max(0.5rem, env(safe-area-inset-right));
        box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.06);
    }

    .bottom-nav-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.15rem;
        padding: 0.5rem 0.25rem;
        min-height: 48px;
        background: transparent;
        border: none;
        color: var(--gray-600);
        cursor: pointer;
        font-size: 0.7rem;
        transition: color 0.15s ease;
    }

    .bottom-nav-item:hover,
    .bottom-nav-item:focus,
    .bottom-nav-item:focus-visible {
        background: var(--gray-100);
        color: var(--gray-700);
    }

    .bottom-nav-item:active {
        background: var(--gray-200);
    }

    .bottom-nav-item.active {
        color: var(--primary);
    }

    .bottom-nav-item.active:hover,
    .bottom-nav-item.active:focus {
        color: var(--primary);
        background: var(--gray-100);
    }

    .bottom-nav-icon {
        font-size: 1.2rem;
    }

    .bottom-nav-badge {
        position: absolute;
        top: -4px;
        right: -6px;
        min-width: 16px;
        height: 16px;
        padding: 0 3px;
        background: var(--primary);
        color: #fff;
        border-radius: 8px;
        font-size: 0.6rem;
        font-weight: 700;
        line-height: 16px;
        text-align: center;
        pointer-events: none;
    }

    .bottom-nav-label {
        font-weight: 500;
        letter-spacing: 0.01em;
    }

    .nav-toggle,
    .nav-drawer {
        display: none !important;
    }

    .header-theme {
        display: inline-flex;
        align-items: center;
        margin-left: auto;
    }

    .details-section .tabs {
        display: none;
    }

    .install-prompt {
        bottom: calc(64px + env(safe-area-inset-bottom) + 0.5rem);
    }

    .toast {
        bottom: calc(64px + env(safe-area-inset-bottom) + 0.5rem);
    }

    .comparison-action-bar {
        bottom: calc(64px + env(safe-area-inset-bottom));
        padding-bottom: 0.875rem;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 1rem;
        padding-bottom: calc(64px + env(safe-area-inset-bottom) + 1rem);
        padding-left: max(1rem, env(safe-area-inset-left));
        padding-right: max(1rem, env(safe-area-inset-right));
    }

    .header-content {
        padding: 0.625rem 1rem;
    }

    .nav-drawer-content {
        padding: 0.625rem 1rem;
    }

    .card {
        padding: 1rem;
    }

    main {
        gap: 1rem;
    }

    .section-header {
        gap: 0.5rem;
        margin-bottom: 1rem;
    }

    .tabs {
        margin-bottom: 1rem;
    }

    .action-buttons {
        flex-wrap: wrap;
        gap: 0.25rem;
    }

    .search-controls {
        flex-direction: column;
    }

    .search-controls .search-input-wrap,
    .search-controls > button {
        width: 100%;
    }

    .search-input-wrap input {
        width: 100%;
    }

    .saved-swimmer-filter-row {
        flex-wrap: wrap;
    }

    .saved-swimmer-filter-row select {
        flex: 1;
        min-width: 0;
    }

    .saved-swimmer-filter-row .saved-swimmer-search-filter {
        flex: 1 0 100%;
        width: 100%;
    }
}

@media (max-width: 480px) {
    :root {
        --h1: 1.125rem;
    }

    .container {
        padding: 0.625rem;
        padding-bottom: calc(64px + env(safe-area-inset-bottom) + 0.625rem);
        padding-left: max(0.625rem, env(safe-area-inset-left));
        padding-right: max(0.625rem, env(safe-area-inset-right));
    }

    .header-content {
        padding: 0.5rem 0.75rem;
        gap: 0.625rem;
    }

    .nav-drawer-content {
        padding: 0.5rem 0.75rem;
    }

    .card {
        padding: 0.875rem;
    }

    main {
        gap: 0.625rem;
    }

    .section-header {
        margin-bottom: 0.75rem;
    }

    .swimmer-info {
        grid-template-columns: 1fr;
        gap: 0.375rem;
        padding: 0.75rem;
        margin-bottom: 1rem;
    }

    .tabs {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin-bottom: 0.75rem;
        scrollbar-width: none;
    }

    .tabs::-webkit-scrollbar {
        display: none;
    }

    .tab-btn {
        padding: 0.625rem 0.875rem;
        white-space: nowrap;
        flex-shrink: 0;
    }

    .filter-section {
        flex-direction: column;
        gap: 0.5rem;
        margin-bottom: 1rem;
    }

    .filter-section > div {
        width: 100%;
    }

    .filter-section select,
    .filter-section input[type="text"] {
        min-width: unset;
        width: 100%;
    }

    .comparison-swimmer-tag {
        min-width: 0;
    }

    .pagination {
        margin-top: 0.75rem;
        gap: 0.5rem;
    }

    .empty-state {
        padding: 2rem 1rem;
    }

    .search-carousel {
        padding: 0.95rem 0.3rem 1.5rem;
        border-radius: 10px;
    }

    .search-carousel-nav {
        width: 1.6rem;
        height: 1.6rem;
        font-size: 0.8rem;
    }

    .search-carousel-slide p {
        max-width: none;
    }
}

@media (min-width: 900px) {
    .search-carousel {
        padding: 1.3rem 0.6rem 1.8rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/styles/responsive.css"],"names":[],"mappings":"AAAA;IACI;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,OAAO;QACP,kBAAkB;IACtB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,WAAW;QACX,mBAAmB;QACnB,sBAAsB;QACtB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,OAAO;QACP,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,iCAAiC;QACjC,kBAAkB;QAClB,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;QACvB,uBAAuB;QACvB,wCAAwC;QACxC,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,sBAAsB;QACtB,gCAAgC;QAChC,gBAAgB;QAChB,cAAc;QACd,UAAU;QACV,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;QAC7B,mBAAmB;QACnB,oEAAoE;QACpE,qBAAqB;IACzB;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,OAAO;QACP,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;;QAEI,iCAAiC;QACjC,kBAAkB;QAClB,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,cAAc;QACd,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;;QAEI,mBAAmB;QACnB,aAAa;QACb,uBAAuB;QACvB,iBAAiB;QACjB,wCAAwC;IAC5C;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,wCAAwC,aAAa,EAAE;IACvD,oCAAoC,aAAa,EAAE;IACnD,yBAAyB,aAAa,EAAE;IACxC,0BAA0B,wDAAwD,EAAE;;IAEpF;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,OAAO;QACP,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,OAAO;QACP,aAAa;QACb,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,OAAO;QACP,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,OAAO;IACX;;IAEA;QACI,OAAO;QACP,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,OAAO;QACP,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,YAAY;QACZ,6BAA6B;QAC7B,qCAAqC;QACrC,kBAAkB;QAClB,2DAA2D;QAC3D,oDAAoD;QACpD,sDAAsD;QACtD,2CAA2C;IAC/C;;IAEA;QACI,OAAO;QACP,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,uBAAuB;QACvB,gBAAgB;QAChB,uBAAuB;QACvB,YAAY;QACZ,sBAAsB;QACtB,eAAe;QACf,iBAAiB;QACjB,4BAA4B;IAChC;;IAEA;;;QAGI,2BAA2B;QAC3B,sBAAsB;IAC1B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;QACrB,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,eAAe;QACf,YAAY;QACZ,cAAc;QACd,0BAA0B;QAC1B,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yDAAyD;IAC7D;;IAEA;QACI,yDAAyD;IAC7D;;IAEA;QACI,gDAAgD;QAChD,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,+DAA+D;QAC/D,kDAAkD;QAClD,oDAAoD;IACxD;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,OAAO;QACP,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,mEAAmE;QACnE,sDAAsD;QACtD,wDAAwD;IAC5D;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,iCAAiC;QACjC,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ","sourcesContent":["@media (min-width: 900px) {\n    main {\n        grid-template-columns: 1fr;\n        align-items: start;\n    }\n\n    .sidebar-column {\n        display: grid;\n        grid-template-columns: 1fr 2fr;\n        gap: 1.5rem;\n        align-items: start;\n    }\n\n    main.main-detail-open {\n        grid-template-columns: minmax(280px, 360px) 1fr;\n    }\n\n    main.main-detail-open .sidebar-column {\n        display: flex;\n        flex-direction: column;\n        gap: 1.5rem;\n    }\n\n    main.main-detail-open .detail-column {\n        display: flex;\n        flex-direction: column;\n        gap: 1.5rem;\n        min-width: 0;\n    }\n\n    main.main-detail-open .search-section,\n    main.main-detail-open .saved-section {\n        padding: 1.25rem;\n    }\n\n    main.main-detail-open .search-results-grid,\n    main.main-detail-open .saved-swimmers-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 600px) {\n    .pending-load-fields {\n        grid-template-columns: 1fr;\n    }\n\n    .filter-section .rankings-age-controls {\n        width: 100%;\n    }\n\n    .segmented-toggle {\n        display: flex;\n        width: 100%;\n    }\n\n    .segmented-toggle button {\n        flex: 1;\n        text-align: center;\n    }\n\n    .segmented-toggle .age-group-inline {\n        flex: 1;\n    }\n\n    .segmented-toggle .age-group-affordance {\n        width: 100%;\n    }\n\n    .filter-collapse-toggle {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        width: 100%;\n        padding: 0.375rem 0;\n        color: var(--gray-700);\n        font-size: 0.8rem;\n        text-align: left;\n    }\n\n    .filter-collapse-icon {\n        font-size: 0.75rem;\n        color: var(--gray-400);\n    }\n\n    .filter-collapse-summary {\n        flex: 1;\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    .filter-section.filters-collapsed > *:not(.filter-collapse-toggle) {\n        display: none;\n    }\n\n    .filter-section.filters-collapsed {\n        margin-bottom: 0.75rem;\n    }\n\n    .club-group .table-container {\n        padding: 0.75rem;\n        overflow-x: visible;\n    }\n\n    .hide-on-mobile {\n        display: none !important;\n    }\n\n    .table-container {\n        border: none;\n        border-radius: 0;\n        overflow-x: visible;\n    }\n\n    table {\n        display: block;\n    }\n\n    table thead {\n        display: none;\n    }\n\n    table tbody {\n        display: block;\n    }\n\n    table tbody tr {\n        display: block;\n        margin-bottom: 0.5rem;\n        border: 1px solid var(--gray-200);\n        border-radius: 6px;\n        overflow: hidden;\n        background: var(--bg-primary);\n    }\n\n    table tbody tr:last-child {\n        margin-bottom: 0;\n    }\n\n    table tbody tr:hover {\n        background: var(--bg-primary);\n    }\n\n    table tbody td {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        padding: 0.3rem 0.75rem;\n        border-bottom: 1px solid var(--gray-100);\n        gap: 0.75rem;\n        text-align: right;\n        min-height: auto;\n    }\n\n    table tbody td:last-child {\n        border-bottom: none;\n    }\n\n    table tbody td::before {\n        content: attr(data-label);\n        font-weight: 600;\n        color: var(--gray-600);\n        font-size: calc(var(--h1) * 0.6);\n        text-align: left;\n        flex-shrink: 0;\n        width: 38%;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        padding-top: 0.1rem;\n    }\n\n    table tbody tr:last-child td {\n        border-bottom: none;\n    }\n\n    td.card-event-td {\n        display: block;\n        text-align: left;\n    }\n\n    td.card-event-td::before {\n        display: none;\n    }\n\n    .rankings-cards table tbody tr {\n        border-color: var(--gray-100);\n        border-radius: 10px;\n        box-shadow: 0 1px 2px rbg(0 0 0 / 0.07), 0 1px 3px rgb(0 0 0 / 0.04);\n        margin-bottom: 0.6rem;\n    }\n\n    .rankings-cards td.card-event-td {\n        padding: 0.7rem 0.85rem 0.8rem;\n        border-bottom: none;\n    }\n\n    .rankings-cards .card-event-header {\n        font-size: 0.95rem;\n        font-weight: 700;\n        line-height: 1.35;\n    }\n\n    .rankings-cards .card-inline-time {\n        font-size: 1.02rem;\n        font-weight: 700;\n    }\n\n    .mobile-supplement {\n        display: block;\n    }\n\n    .mobile-supplement.comparison-rank-list {\n        display: flex;\n        flex-direction: column;\n        gap: 0.2rem;\n        margin-top: 0.35rem;\n    }\n\n    table tbody td > div {\n        flex: 1;\n        justify-content: flex-end;\n        min-height: auto !important;\n    }\n\n    .splits-drilldown-row {\n        border: none;\n        border-radius: 0;\n        background: transparent;\n        margin-bottom: 0;\n    }\n\n    .club-group .splits-panel,\n    .splits-panel {\n        border: 1px solid var(--gray-200);\n        border-radius: 6px;\n        overflow: hidden;\n        padding: 0;\n    }\n\n    .splits-panel table {\n        display: table;\n        width: 100%;\n        table-layout: fixed;\n    }\n\n    .splits-panel thead {\n        display: table-header-group;\n    }\n\n    .splits-panel tbody {\n        display: table-row-group;\n    }\n\n    .splits-panel thead tr,\n    .splits-panel tbody tr {\n        display: table-row;\n        margin: 0;\n        border: none;\n        border-radius: 0;\n        background: transparent;\n    }\n\n    .splits-panel th,\n    .splits-panel td {\n        display: table-cell;\n        width: 33.33%;\n        padding: 0.35rem 0.6rem;\n        text-align: right;\n        border-bottom: 1px solid var(--gray-100);\n    }\n\n    .splits-panel th:first-child,\n    .splits-panel td:first-child {\n        text-align: left;\n    }\n\n    .splits-panel tbody tr:last-child td {\n        border-bottom: none;\n    }\n\n    .splits-panel td:before {\n        display: none;\n    }\n}\n\n@media (max-width: 768px) {\n    .mobile-view:not(.mobile-view-active) { display: none; }\n    .mobile-view.mobile-detail-active { display: none; }\n    .panel-collapse-toggle { display: none; }\n    .swimmer-details-anchor { scroll-margin-top: calc(72px + env(safe-area-inset-top)); }\n\n    body {\n        display: flex;\n        flex-direction: column;\n    }\n\n    #root {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .container {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    }\n\n    main:not(.main-detail-open) {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n    }\n\n    main:not(.main-detail-open) .sidebar-column {\n        flex: 1;\n    }\n\n    main:not(.main-detail-open) .mobile-view.mobile-view-active {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n    }\n\n    .search-section-empty {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .search-section-empty #searchResults {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .search-section-empty .search-carousel {\n        flex: 1;\n    }\n\n    .bottom-nav {\n        display: flex;\n        gap: 0.25rem;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 100;\n        background: var(--bg-primary);\n        border-top: 1px solid var(--gray-200);\n        padding: 0.25rem 0;\n        padding-bottom: calc(0.25rem + env(safe-area-inset-bottom));\n        padding-left: max(0.5rem, env(safe-area-inset-left));\n        padding-right: max(0.5rem, env(safe-area-inset-right));\n        box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.06);\n    }\n\n    .bottom-nav-item {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 0.15rem;\n        padding: 0.5rem 0.25rem;\n        min-height: 48px;\n        background: transparent;\n        border: none;\n        color: var(--gray-600);\n        cursor: pointer;\n        font-size: 0.7rem;\n        transition: color 0.15s ease;\n    }\n\n    .bottom-nav-item:hover,\n    .bottom-nav-item:focus,\n    .bottom-nav-item:focus-visible {\n        background: var(--gray-100);\n        color: var(--gray-700);\n    }\n\n    .bottom-nav-item:active {\n        background: var(--gray-200);\n    }\n\n    .bottom-nav-item.active {\n        color: var(--primary);\n    }\n\n    .bottom-nav-item.active:hover,\n    .bottom-nav-item.active:focus {\n        color: var(--primary);\n        background: var(--gray-100);\n    }\n\n    .bottom-nav-icon {\n        font-size: 1.2rem;\n    }\n\n    .bottom-nav-badge {\n        position: absolute;\n        top: -4px;\n        right: -6px;\n        min-width: 16px;\n        height: 16px;\n        padding: 0 3px;\n        background: var(--primary);\n        color: #fff;\n        border-radius: 8px;\n        font-size: 0.6rem;\n        font-weight: 700;\n        line-height: 16px;\n        text-align: center;\n        pointer-events: none;\n    }\n\n    .bottom-nav-label {\n        font-weight: 500;\n        letter-spacing: 0.01em;\n    }\n\n    .nav-toggle,\n    .nav-drawer {\n        display: none !important;\n    }\n\n    .header-theme {\n        display: inline-flex;\n        align-items: center;\n        margin-left: auto;\n    }\n\n    .details-section .tabs {\n        display: none;\n    }\n\n    .install-prompt {\n        bottom: calc(64px + env(safe-area-inset-bottom) + 0.5rem);\n    }\n\n    .toast {\n        bottom: calc(64px + env(safe-area-inset-bottom) + 0.5rem);\n    }\n\n    .comparison-action-bar {\n        bottom: calc(64px + env(safe-area-inset-bottom));\n        padding-bottom: 0.875rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .container {\n        padding: 1rem;\n        padding-bottom: calc(64px + env(safe-area-inset-bottom) + 1rem);\n        padding-left: max(1rem, env(safe-area-inset-left));\n        padding-right: max(1rem, env(safe-area-inset-right));\n    }\n\n    .header-content {\n        padding: 0.625rem 1rem;\n    }\n\n    .nav-drawer-content {\n        padding: 0.625rem 1rem;\n    }\n\n    .card {\n        padding: 1rem;\n    }\n\n    main {\n        gap: 1rem;\n    }\n\n    .section-header {\n        gap: 0.5rem;\n        margin-bottom: 1rem;\n    }\n\n    .tabs {\n        margin-bottom: 1rem;\n    }\n\n    .action-buttons {\n        flex-wrap: wrap;\n        gap: 0.25rem;\n    }\n\n    .search-controls {\n        flex-direction: column;\n    }\n\n    .search-controls .search-input-wrap,\n    .search-controls > button {\n        width: 100%;\n    }\n\n    .search-input-wrap input {\n        width: 100%;\n    }\n\n    .saved-swimmer-filter-row {\n        flex-wrap: wrap;\n    }\n\n    .saved-swimmer-filter-row select {\n        flex: 1;\n        min-width: 0;\n    }\n\n    .saved-swimmer-filter-row .saved-swimmer-search-filter {\n        flex: 1 0 100%;\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    :root {\n        --h1: 1.125rem;\n    }\n\n    .container {\n        padding: 0.625rem;\n        padding-bottom: calc(64px + env(safe-area-inset-bottom) + 0.625rem);\n        padding-left: max(0.625rem, env(safe-area-inset-left));\n        padding-right: max(0.625rem, env(safe-area-inset-right));\n    }\n\n    .header-content {\n        padding: 0.5rem 0.75rem;\n        gap: 0.625rem;\n    }\n\n    .nav-drawer-content {\n        padding: 0.5rem 0.75rem;\n    }\n\n    .card {\n        padding: 0.875rem;\n    }\n\n    main {\n        gap: 0.625rem;\n    }\n\n    .section-header {\n        margin-bottom: 0.75rem;\n    }\n\n    .swimmer-info {\n        grid-template-columns: 1fr;\n        gap: 0.375rem;\n        padding: 0.75rem;\n        margin-bottom: 1rem;\n    }\n\n    .tabs {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        margin-bottom: 0.75rem;\n        scrollbar-width: none;\n    }\n\n    .tabs::-webkit-scrollbar {\n        display: none;\n    }\n\n    .tab-btn {\n        padding: 0.625rem 0.875rem;\n        white-space: nowrap;\n        flex-shrink: 0;\n    }\n\n    .filter-section {\n        flex-direction: column;\n        gap: 0.5rem;\n        margin-bottom: 1rem;\n    }\n\n    .filter-section > div {\n        width: 100%;\n    }\n\n    .filter-section select,\n    .filter-section input[type=\"text\"] {\n        min-width: unset;\n        width: 100%;\n    }\n\n    .comparison-swimmer-tag {\n        min-width: 0;\n    }\n\n    .pagination {\n        margin-top: 0.75rem;\n        gap: 0.5rem;\n    }\n\n    .empty-state {\n        padding: 2rem 1rem;\n    }\n\n    .search-carousel {\n        padding: 0.95rem 0.3rem 1.5rem;\n        border-radius: 10px;\n    }\n\n    .search-carousel-nav {\n        width: 1.6rem;\n        height: 1.6rem;\n        font-size: 0.8rem;\n    }\n\n    .search-carousel-slide p {\n        max-width: none;\n    }\n}\n\n@media (min-width: 900px) {\n    .search-carousel {\n        padding: 1.3rem 0.6rem 1.8rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
